import React from 'react'
import AudioPlayer from "./AudioPlayer";
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBSpinner  } from 'mdb-react-ui-kit';
import { useGlobalContext } from './context'


const App = () => {

    const {isLoading} = useGlobalContext();
    
    if(isLoading) {
        return (
            <div className='d-flex align-items-center justify-content-center'>
              <MDBSpinner role='status' color='info' style={{ width: '6rem', height: '6rem' }}>
                <span className='visually-hidden'>Loading...</span>
              </MDBSpinner>
            </div>
          );
    }
    else {
        return (
            <React.Fragment>
                <MDBContainer fluid className="shadow-1-strong">
                    <MDBRow className="py-3">
                        <MDBCol>
                            <div className="title-container text-left">
                                <h1 className="text-light">Audio Book</h1>  
                            </div>
                        </MDBCol>
                        <MDBCol className="d-flex justify-content-end">
                            <MDBIcon icon='backspace' size='4x' className="icon-exit-page text-info" onClick={() => {window.history.back();}}/>
                        </MDBCol>  
                    </MDBRow>   
                </MDBContainer>
                <AudioPlayer className="audio-list-item"/> 
            </React.Fragment>            
        )
    }
}

export default App
